
export const graphValues = {
    "graphdata": {
        "names": [
            "Excavation",
            "Plumbing",
            "Pre-pour Inspection",
            "Foundation",
            "Framing",
            "Roofing",
            "Windows-Doors",
            "Plumbing",
            "HVAC Ductwork",
            "Outer Insulation",
            "Electrical Wiring",
            "Framing Inspection",
            "Masonry/Siding",
            "Interior Insulation",
            "Flooring",
            "Drywall",
            "Mudding",
            "Cabinetry/Trim",
            "Painting",
            "Plumbing Fixtures",
            "HVAC Fixtures",
            "Carpeting",
            "Electrical Fixtures",
            "Gutters",
            "Driveway/Landscaping",
            "Final Inspection"
        ],
        "links": [
            {
                "u": "A",
                "v": "B",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "B",
                "v": "C",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "C",
                "v": "D",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "D",
                "v": "E",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "E",
                "v": "F",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "F",
                "v": "G",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "E",
                "v": "H",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "E",
                "v": "I",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "E",
                "v": "J",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "J",
                "v": "K",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "K",
                "v": "L",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "H",
                "v": "L",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "I",
                "v": "L",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "G",
                "v": "L",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "L",
                "v": "M",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "L",
                "v": "N",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "L",
                "v": "O",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "M",
                "v": "X",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "X",
                "v": "Y",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "Y",
                "v": "Z",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "N",
                "v": "P",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "P",
                "v": "Q",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "Q",
                "v": "S",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "S",
                "v": "T",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "S",
                "v": "U",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "S",
                "v": "V",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "T",
                "v": "W",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "U",
                "v": "W",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "W",
                "v": "Z",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "V",
                "v": "Z",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "O",
                "v": "R",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "P",
                "v": "R",
                "value": {
                    "label": ""
                }
            },
            {
                "u": "R",
                "v": "S",
                "value": {
                    "label": ""
                }
            }
        ],
        "criticalPaths": [
            "ABCDEFGLNPQSUWZ",
            "ABCDEHLNPQSUWZ",
            "ABCDEILNPQSUWZ",
            "ABCDEJKLNPQSUWZ",
            "ABCDEFGLORSUWZ",
            "ABCDEHLORSUWZ",
            "ABCDEILORSUWZ",
            "ABCDEJKLORSUWZ",
            "ABCDEFGLNPRSUWZ",
            "ABCDEHLNPRSUWZ",
            "ABCDEILNPRSUWZ",
            "ABCDEJKLNPRSUWZ",
            "ABCDEFGLNPQSTWZ",
            "ABCDEHLNPQSTWZ",
            "ABCDEILNPQSTWZ",
            "ABCDEJKLNPQSTWZ",
            "ABCDEFGLORSTWZ",
            "ABCDEHLORSTWZ",
            "ABCDEILORSTWZ",
            "ABCDEJKLORSTWZ",
            "ABCDEFGLNPRSTWZ",
            "ABCDEHLNPRSTWZ",
            "ABCDEILNPRSTWZ",
            "ABCDEJKLNPRSTWZ",
            "ABCDEFGLNPQSVZ",
            "ABCDEHLNPQSVZ",
            "ABCDEILNPQSVZ",
            "ABCDEJKLNPQSVZ",
            "ABCDEFGLORSVZ",
            "ABCDEHLORSVZ",
            "ABCDEILORSVZ",
            "ABCDEJKLORSVZ",
            "ABCDEFGLNPRSVZ",
            "ABCDEHLNPRSVZ",
            "ABCDEILNPRSVZ",
            "ABCDEJKLNPRSVZ",
            "ABCDEFGLMXYZ",
            "ABCDEHLMXYZ",
            "ABCDEILMXYZ",
            "ABCDEJKLMXYZ"
        ]
    }
}

export const uiDataObject = {
    "projectedCompletionTime": 114,
    "deadLineDays": 64,
    "homeOwnerMorale": "Neutral",
    "subContractorMorale": "Negative",
    "projectedProfitValue": -45253,
    "projectedProfitPercentage": -25.14,
    "profitPerformanceValue": "Going Bankrupt",
    "totalRandomEventDays": 15,
    "stage": 61,
    "calculatedDeadlineDays": 125,
    "costParameters": [
        {
            "label": "Projected Project Cost",
            "value": 225253,
            "projectProfit": -45253,
            "status": 45253,
            "css": "over"
        },
        {
            "label": "Projected Completion",
            "value": 114,
            "status": "11 days ahead of time",
            "css": "less"
        },
        {
            "label": "Project Status",
            "value": "Ahead of Schedule",
            "css": "ahead of schedule"
        }
    ],
    "tasks": [
        {
            "taskId": "A",
            "actualCost": 7872,
            "actualTime": 6,
            "elapsedTime": 6,
            "earlyStart": 0,
            "earlyFinish": 6,
            "lateStart": 0,
            "lateFinish": 6,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "B",
            "actualCost": 3724,
            "actualTime": 3,
            "elapsedTime": 3,
            "earlyStart": 6,
            "earlyFinish": 9,
            "lateStart": 6,
            "lateFinish": 9,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "C",
            "actualCost": 150,
            "actualTime": 1,
            "elapsedTime": 1,
            "earlyStart": 9,
            "earlyFinish": 10,
            "lateStart": 9,
            "lateFinish": 10,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "D",
            "actualCost": 21604,
            "actualTime": 9,
            "elapsedTime": 9,
            "earlyStart": 10,
            "earlyFinish": 19,
            "lateStart": 10,
            "lateFinish": 19,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "E",
            "actualCost": 36980,
            "actualTime": 14,
            "elapsedTime": 14,
            "earlyStart": 19,
            "earlyFinish": 33,
            "lateStart": 19,
            "lateFinish": 33,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "F",
            "actualCost": 7740,
            "actualTime": 7,
            "elapsedTime": 7,
            "earlyStart": 33,
            "earlyFinish": 40,
            "lateStart": 33,
            "lateFinish": 40,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "G",
            "actualCost": 8304,
            "actualTime": 3,
            "elapsedTime": 3,
            "earlyStart": 40,
            "earlyFinish": 43,
            "lateStart": 40,
            "lateFinish": 43,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "H",
            "actualCost": 7472,
            "actualTime": 7,
            "elapsedTime": 7,
            "earlyStart": 33,
            "earlyFinish": 40,
            "lateStart": 36,
            "lateFinish": 43,
            "slackTime": 3,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "I",
            "actualCost": 9546,
            "actualTime": 7,
            "elapsedTime": 7,
            "earlyStart": 33,
            "earlyFinish": 40,
            "lateStart": 36,
            "lateFinish": 43,
            "slackTime": 3,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "J",
            "actualCost": 5972,
            "actualTime": 2,
            "elapsedTime": 2,
            "earlyStart": 33,
            "earlyFinish": 35,
            "lateStart": 34,
            "lateFinish": 36,
            "slackTime": 1,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "K",
            "actualCost": 9690,
            "actualTime": 7,
            "elapsedTime": 7,
            "earlyStart": 35,
            "earlyFinish": 42,
            "lateStart": 36,
            "lateFinish": 43,
            "slackTime": 1,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "L",
            "actualCost": 250,
            "actualTime": 1,
            "elapsedTime": 1,
            "earlyStart": 43,
            "earlyFinish": 44,
            "lateStart": 43,
            "lateFinish": 44,
            "slackTime": 0,
            "currentState": "COMPLETED"
        },
        {
            "taskId": "M",
            "actualCost": 14060,
            "actualTime": 8,
            "elapsedTime": 2,
            "earlyStart": 44,
            "earlyFinish": 52,
            "lateStart": 86,
            "lateFinish": 94,
            "slackTime": 42,
            "currentState": "IN_PROGRESS"
        },
        {
            "taskId": "N",
            "actualCost": 4936,
            "actualTime": 4,
            "elapsedTime": 2,
            "earlyStart": 44,
            "earlyFinish": 48,
            "lateStart": 44,
            "lateFinish": 48,
            "slackTime": 0,
            "currentState": "IN_PROGRESS"
        },
        {
            "taskId": "O",
            "actualCost": 4012,
            "actualTime": 3,
            "elapsedTime": 2,
            "earlyStart": 44,
            "earlyFinish": 47,
            "lateStart": 51,
            "lateFinish": 54,
            "slackTime": 7,
            "currentState": "IN_PROGRESS"
        },
        {
            "taskId": "P",
            "actualCost": 9824,
            "actualTime": 2,
            "elapsedTime": 0,
            "earlyStart": 48,
            "earlyFinish": 50,
            "lateStart": 48,
            "lateFinish": 50,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "Q",
            "actualCost": 7384,
            "actualTime": 11,
            "elapsedTime": 0,
            "earlyStart": 50,
            "earlyFinish": 61,
            "lateStart": 50,
            "lateFinish": 61,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "R",
            "actualCost": 24748,
            "actualTime": 7,
            "elapsedTime": 0,
            "earlyStart": 50,
            "earlyFinish": 57,
            "lateStart": 54,
            "lateFinish": 61,
            "slackTime": 4,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "S",
            "actualCost": 10644,
            "actualTime": 10,
            "elapsedTime": 0,
            "earlyStart": 61,
            "earlyFinish": 71,
            "lateStart": 61,
            "lateFinish": 71,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "T",
            "actualCost": 1680,
            "actualTime": 14,
            "elapsedTime": 0,
            "earlyStart": 71,
            "earlyFinish": 85,
            "lateStart": 71,
            "lateFinish": 85,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "U",
            "actualCost": 2654,
            "actualTime": 5,
            "elapsedTime": 0,
            "earlyStart": 71,
            "earlyFinish": 76,
            "lateStart": 80,
            "lateFinish": 85,
            "slackTime": 9,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "V",
            "actualCost": 6960,
            "actualTime": 3,
            "elapsedTime": 0,
            "earlyStart": 71,
            "earlyFinish": 74,
            "lateStart": 95,
            "lateFinish": 98,
            "slackTime": 24,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "W",
            "actualCost": 1750,
            "actualTime": 13,
            "elapsedTime": 0,
            "earlyStart": 85,
            "earlyFinish": 98,
            "lateStart": 85,
            "lateFinish": 98,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "X",
            "actualCost": 1312,
            "actualTime": 2,
            "elapsedTime": 0,
            "earlyStart": 52,
            "earlyFinish": 54,
            "lateStart": 94,
            "lateFinish": 96,
            "slackTime": 42,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "Y",
            "actualCost": 15560,
            "actualTime": 2,
            "elapsedTime": 0,
            "earlyStart": 54,
            "earlyFinish": 56,
            "lateStart": 96,
            "lateFinish": 98,
            "slackTime": 42,
            "currentState": "NOT_STARTED"
        },
        {
            "taskId": "Z",
            "actualCost": 425,
            "actualTime": 1,
            "elapsedTime": 0,
            "earlyStart": 98,
            "earlyFinish": 99,
            "lateStart": 98,
            "lateFinish": 99,
            "slackTime": 0,
            "currentState": "NOT_STARTED"
        }
    ],
    "date": "March 1",
    "serverCriticalPath": "ABCDEFGLNPQSTWZ",
    "criticalPath": "ABCDEFGLNPQSTWZ",
    "decisionActions": [
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 4,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 1872,
            "standardOptionOverTimeCost": 1248,
            "expensiveOptionOverTimeCost": 624,
            "cheaperOverTimeDays": 3,
            "standardOverTimeDays": 2,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 2,
            "localSupplierCost": 1100,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "A",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "A",
                    "cost": 4900,
                    "days": 11,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Deep Down Excavators"
                },
                {
                    "taskId": "A",
                    "cost": 7000,
                    "days": 7,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Excavation Station"
                },
                {
                    "taskId": "A",
                    "cost": 9000,
                    "days": 5,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Excavators Express"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Excavation"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 624,
            "standardOptionOverTimeCost": 312,
            "expensiveOptionOverTimeCost": 312,
            "cheaperOverTimeDays": 2,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 300,
            "localSuppilerOptionName": "Pay overtime to keep work going",
            "localSupplierOptionAvailable": false,
            "taskId": "B",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "B",
                    "cost": 2800,
                    "days": 6,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Penny Pincher Plumbing"
                },
                {
                    "taskId": "B",
                    "cost": 4000,
                    "days": 4,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Rudy's Plumbing"
                },
                {
                    "taskId": "B",
                    "cost": 5000,
                    "days": 3,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Pipe Dream Plumbing"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Plumbing"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": null,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 0,
            "standardOptionOverTimeCost": 0,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 0,
            "standardOverTimeDays": 0,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": null,
            "localSupplierCost": null,
            "localSuppilerOptionName": null,
            "localSupplierOptionAvailable": false,
            "taskId": "C",
            "taskOptionType": "",
            "pmTaskOptions": [
                {
                    "taskId": "C",
                    "cost": 150,
                    "days": 1,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": null
                }
            ],
            "selectedOptionType": "STANDARD",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Pre-Pour Inspection"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 14,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 13104,
            "standardOptionOverTimeCost": 8736,
            "expensiveOptionOverTimeCost": 6552,
            "cheaperOverTimeDays": 6,
            "standardOverTimeDays": 4,
            "expensiveOverTimeDays": 3,
            "localSupplierDays": 3,
            "localSupplierCost": 1500,
            "localSuppilerOptionName": "Rent equipment to speed up process",
            "localSupplierOptionAvailable": false,
            "taskId": "D",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "D",
                    "cost": 7000,
                    "days": 18,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Bargain Basement Foundations"
                },
                {
                    "taskId": "D",
                    "cost": 10000,
                    "days": 13,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Ace Foundations"
                },
                {
                    "taskId": "D",
                    "cost": 14000,
                    "days": 9,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Fast Frank's Foundations"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Foundation"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 10,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 12480,
            "standardOptionOverTimeCost": 9360,
            "expensiveOptionOverTimeCost": 6240,
            "cheaperOverTimeDays": 8,
            "standardOverTimeDays": 6,
            "expensiveOverTimeDays": 4,
            "localSupplierDays": 2,
            "localSupplierCost": 1000,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": false,
            "taskId": "E",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "E",
                    "cost": 23500,
                    "days": 25,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Frugal Framing"
                },
                {
                    "taskId": "E",
                    "cost": 30500,
                    "days": 18,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "First Step Framers"
                },
                {
                    "taskId": "E",
                    "cost": 36500,
                    "days": 14,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "ASAP Framing"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Framing"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 5,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 2340,
            "standardOptionOverTimeCost": 1560,
            "expensiveOptionOverTimeCost": 780,
            "cheaperOverTimeDays": 3,
            "standardOverTimeDays": 2,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 500,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": false,
            "taskId": "F",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "F",
                    "cost": 4900,
                    "days": 11,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Reasonable Roofing"
                },
                {
                    "taskId": "F",
                    "cost": 7000,
                    "days": 7,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Roof and Tumble Roofers"
                },
                {
                    "taskId": "F",
                    "cost": 9000,
                    "days": 5,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Sky High Roofers"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Roofing"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 3,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 1404,
            "standardOptionOverTimeCost": 936,
            "expensiveOptionOverTimeCost": 468,
            "cheaperOverTimeDays": 3,
            "standardOverTimeDays": 2,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 600,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": false,
            "taskId": "G",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "G",
                    "cost": 6300,
                    "days": 9,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Budget Windows and Doors"
                },
                {
                    "taskId": "G",
                    "cost": 9000,
                    "days": 6,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Jimmy's Windows and Doors"
                },
                {
                    "taskId": "G",
                    "cost": 11000,
                    "days": 4,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Snappy Sam's Windows and Doors"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Windows-Doors"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 3,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 1872,
            "standardOptionOverTimeCost": 1404,
            "expensiveOptionOverTimeCost": 936,
            "cheaperOverTimeDays": 4,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 2,
            "localSupplierCost": 1400,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "H",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "H",
                    "cost": 4200,
                    "days": 13,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Penny Pincher Plumbing"
                },
                {
                    "taskId": "H",
                    "cost": 6000,
                    "days": 9,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Rudy's Plumbing"
                },
                {
                    "taskId": "H",
                    "cost": 9000,
                    "days": 6,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Pipe Dream Plumbing"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Plumbing"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 4,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 2496,
            "standardOptionOverTimeCost": 1872,
            "expensiveOptionOverTimeCost": 1248,
            "cheaperOverTimeDays": 4,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 3,
            "localSupplierCost": 1800,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "I",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "I",
                    "cost": 5250,
                    "days": 14,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "U-Save HVAC"
                },
                {
                    "taskId": "I",
                    "cost": 7500,
                    "days": 10,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Goldilocks HVAC"
                },
                {
                    "taskId": "I",
                    "cost": 10500,
                    "days": 7,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Quick Fix HVAC"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "HVAC Ductwork"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 6,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 1872,
            "standardOptionOverTimeCost": 936,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 2,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": 2,
            "localSupplierCost": 2000,
            "localSuppilerOptionName": "Buy supplies from local hardware store",
            "localSupplierOptionAvailable": false,
            "taskId": "J",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "J",
                    "cost": 2100,
                    "days": 6,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "House Wrappers Discount Insulation"
                },
                {
                    "taskId": "J",
                    "cost": 3000,
                    "days": 3,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Tri-City Insulation"
                },
                {
                    "taskId": "J",
                    "cost": 4000,
                    "days": 2,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Lively Mike's Insulation"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Outer Insulation"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 3,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 2340,
            "standardOptionOverTimeCost": 1404,
            "expensiveOptionOverTimeCost": 936,
            "cheaperOverTimeDays": 5,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 4,
            "localSupplierCost": 1400,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "K",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "K",
                    "cost": 5950,
                    "days": 15,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Downtown Electrical"
                },
                {
                    "taskId": "K",
                    "cost": 8500,
                    "days": 10,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Sparky's Electrical"
                },
                {
                    "taskId": "K",
                    "cost": 11500,
                    "days": 7,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Speed of Light Electrical"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Electrical Wiring"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": null,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 0,
            "standardOptionOverTimeCost": 0,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 0,
            "standardOverTimeDays": 0,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": null,
            "localSupplierCost": null,
            "localSuppilerOptionName": null,
            "localSupplierOptionAvailable": false,
            "taskId": "L",
            "taskOptionType": "",
            "pmTaskOptions": [
                {
                    "taskId": "L",
                    "cost": 250,
                    "days": 1,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": null
                }
            ],
            "selectedOptionType": "STANDARD",
            "taskOptionAvailable": false,
            "taskState": "COMPLETED",
            "taskName": "Framing Inspection"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 7,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 5460,
            "standardOptionOverTimeCost": 3276,
            "expensiveOptionOverTimeCost": 2184,
            "cheaperOverTimeDays": 5,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 3,
            "localSupplierCost": 900,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "M",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "M",
                    "cost": 7700,
                    "days": 16,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Rock Bottom Masonry and Siding"
                },
                {
                    "taskId": "M",
                    "cost": 11000,
                    "days": 11,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Stone's Throw Masonry and Siding"
                },
                {
                    "taskId": "M",
                    "cost": 14000,
                    "days": 8,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Swift Masonry and Siding"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "IN_PROGRESS",
            "taskName": "Masonry/Siding"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 3,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 936,
            "standardOptionOverTimeCost": 468,
            "expensiveOptionOverTimeCost": 468,
            "cheaperOverTimeDays": 2,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 1200,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "N",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "N",
                    "cost": 2800,
                    "days": 7,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Dollar Dan's Interior Insulation"
                },
                {
                    "taskId": "N",
                    "cost": 4000,
                    "days": 4,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Inside Job Interior Insulation"
                },
                {
                    "taskId": "N",
                    "cost": 5000,
                    "days": 3,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "In-and-Out Interior Insulation"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "IN_PROGRESS",
            "taskName": "Interior Insulation"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 312,
            "standardOptionOverTimeCost": 312,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 1,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": 1,
            "localSupplierCost": 900,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": false,
            "taskId": "O",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "O",
                    "cost": 2800,
                    "days": 5,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Down Low Flooring"
                },
                {
                    "taskId": "O",
                    "cost": 4000,
                    "days": 3,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Allen and Sons Flooring"
                },
                {
                    "taskId": "O",
                    "cost": 5000,
                    "days": 2,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Fleet Foot Flooring"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "IN_PROGRESS",
            "taskName": "Flooring"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 4,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 1872,
            "standardOptionOverTimeCost": 1248,
            "expensiveOptionOverTimeCost": 624,
            "cheaperOverTimeDays": 3,
            "standardOverTimeDays": 2,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 2,
            "localSupplierCost": 1200,
            "localSuppilerOptionName": "Buy supplies from local hardware store",
            "localSupplierOptionAvailable": true,
            "taskId": "P",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "P",
                    "cost": 4200,
                    "days": 11,
                    "optionType": "CHEAPER",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Discount Drywall"
                },
                {
                    "taskId": "P",
                    "cost": 6000,
                    "days": 7,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Room and Board Drywall"
                },
                {
                    "taskId": "P",
                    "cost": 8000,
                    "days": 5,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "On the Double Drywall"
                }
            ],
            "selectedOptionType": "EXPENSIVE",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Drywall"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 2184,
            "standardOptionOverTimeCost": 1560,
            "expensiveOptionOverTimeCost": 936,
            "cheaperOverTimeDays": 7,
            "standardOverTimeDays": 5,
            "expensiveOverTimeDays": 3,
            "localSupplierDays": 3,
            "localSupplierCost": 2400,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": true,
            "taskId": "Q",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "Q",
                    "cost": 2800,
                    "days": 21,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Price Busters Mudding"
                },
                {
                    "taskId": "Q",
                    "cost": 4000,
                    "days": 15,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "WIlson Mudding, Inc."
                },
                {
                    "taskId": "Q",
                    "cost": 8000,
                    "days": 11,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Beast Mode Mudding"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Mudding"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 2184,
            "standardOptionOverTimeCost": 1560,
            "expensiveOptionOverTimeCost": 1248,
            "cheaperOverTimeDays": 7,
            "standardOverTimeDays": 5,
            "expensiveOverTimeDays": 4,
            "localSupplierDays": 1,
            "localSupplierCost": 2000,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": true,
            "taskId": "R",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "R",
                    "cost": 12250,
                    "days": 23,
                    "optionType": "CHEAPER",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Heaven Cent Cabinetry"
                },
                {
                    "taskId": "R",
                    "cost": 17500,
                    "days": 16,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Olde Towne Cabinetry"
                },
                {
                    "taskId": "R",
                    "cost": 21500,
                    "days": 12,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Luxury Cabinets"
                }
            ],
            "selectedOptionType": "EXPENSIVE",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Cabinetry/Trim"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 4,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 3744,
            "standardOptionOverTimeCost": 2496,
            "expensiveOptionOverTimeCost": 1872,
            "cheaperOverTimeDays": 6,
            "standardOverTimeDays": 4,
            "expensiveOverTimeDays": 3,
            "localSupplierDays": 2,
            "localSupplierCost": 2000,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": true,
            "taskId": "S",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "S",
                    "cost": 4900,
                    "days": 18,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Perfect Price Painters"
                },
                {
                    "taskId": "S",
                    "cost": 7000,
                    "days": 13,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "M & C Painting"
                },
                {
                    "taskId": "S",
                    "cost": 11000,
                    "days": 9,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Pronto Painting"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Painting"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 1248,
            "standardOptionOverTimeCost": 936,
            "expensiveOptionOverTimeCost": 624,
            "cheaperOverTimeDays": 4,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 1,
            "localSupplierCost": 1000,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": true,
            "taskId": "T",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "T",
                    "cost": 1680,
                    "days": 14,
                    "optionType": "CHEAPER",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Penny Pincher Plumbing"
                },
                {
                    "taskId": "T",
                    "cost": 2400,
                    "days": 9,
                    "optionType": "STANDARD",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Rudy's Plumbing"
                },
                {
                    "taskId": "T",
                    "cost": 5400,
                    "days": 6,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Pipe Dream Plumbing"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "NOT_STARTED",
            "taskName": "Plumbing Fixtures"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 624,
            "standardOptionOverTimeCost": 312,
            "expensiveOptionOverTimeCost": 312,
            "cheaperOverTimeDays": 2,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 700,
            "localSuppilerOptionName": "Pay for rush delivery",
            "localSupplierOptionAvailable": true,
            "taskId": "U",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "U",
                    "cost": 1330,
                    "days": 8,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "U-Save HVAC"
                },
                {
                    "taskId": "U",
                    "cost": 1900,
                    "days": 4,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Goldilocks HVAC"
                },
                {
                    "taskId": "U",
                    "cost": 2900,
                    "days": 3,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Quick Fix HVAC"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "NOT_STARTED",
            "taskName": "HVAC Fixtures"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 5,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 1560,
            "standardOptionOverTimeCost": 780,
            "expensiveOptionOverTimeCost": 780,
            "cheaperOverTimeDays": 2,
            "standardOverTimeDays": 1,
            "expensiveOverTimeDays": 1,
            "localSupplierDays": 1,
            "localSupplierCost": 1200,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": true,
            "taskId": "V",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "V",
                    "cost": 4200,
                    "days": 6,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Low-Cost Carpeting"
                },
                {
                    "taskId": "V",
                    "cost": 6000,
                    "days": 4,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Carpet Genie"
                },
                {
                    "taskId": "V",
                    "cost": 7000,
                    "days": 3,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Carpet Diem Same-Day Carpeting"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Carpeting"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 3,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 1872,
            "standardOptionOverTimeCost": 1404,
            "expensiveOptionOverTimeCost": 936,
            "cheaperOverTimeDays": 4,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 2,
            "localSupplierCost": 1000,
            "localSuppilerOptionName": "Pay overtime to keep work going",
            "localSupplierOptionAvailable": true,
            "taskId": "W",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "W",
                    "cost": 1750,
                    "days": 13,
                    "optionType": "CHEAPER",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Downtown Electrical"
                },
                {
                    "taskId": "W",
                    "cost": 2500,
                    "days": 9,
                    "optionType": "STANDARD",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Sparky's Electrical"
                },
                {
                    "taskId": "W",
                    "cost": 5500,
                    "days": 6,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Speed of Light Electrical"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": false,
            "taskState": "NOT_STARTED",
            "taskName": "Electrical Fixtures"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 2,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 312,
            "standardOptionOverTimeCost": 0,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 1,
            "standardOverTimeDays": 0,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": 1,
            "localSupplierCost": 300,
            "localSuppilerOptionName": "Increase number of workers",
            "localSupplierOptionAvailable": true,
            "taskId": "X",
            "taskOptionType": "Subcontractor",
            "pmTaskOptions": [
                {
                    "taskId": "X",
                    "cost": 700,
                    "days": 4,
                    "optionType": "CHEAPER",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Cost Cutter Gutters"
                },
                {
                    "taskId": "X",
                    "cost": 1000,
                    "days": 2,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Gary's Gutters"
                },
                {
                    "taskId": "X",
                    "cost": 2000,
                    "days": 1,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Gitter Done Gutters"
                }
            ],
            "selectedOptionType": "CHEAPER",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Gutters"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": 5,
            "overTimeOptionAvailable": true,
            "cheaperOptionOverTimeCost": 3120,
            "standardOptionOverTimeCost": 2340,
            "expensiveOptionOverTimeCost": 1560,
            "cheaperOverTimeDays": 4,
            "standardOverTimeDays": 3,
            "expensiveOverTimeDays": 2,
            "localSupplierDays": 2,
            "localSupplierCost": 1000,
            "localSuppilerOptionName": "Buy supplies from local hardware store",
            "localSupplierOptionAvailable": true,
            "taskId": "Y",
            "taskOptionType": "Supplier",
            "pmTaskOptions": [
                {
                    "taskId": "Y",
                    "cost": 7000,
                    "days": 14,
                    "optionType": "CHEAPER",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Less is More Landscaping"
                },
                {
                    "taskId": "Y",
                    "cost": 10000,
                    "days": 9,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": "Curb Appeal Landscaping"
                },
                {
                    "taskId": "Y",
                    "cost": 13000,
                    "days": 6,
                    "optionType": "EXPENSIVE",
                    "overTimeSelected": true,
                    "localSupplierSelected": true,
                    "companyName": "Lickety Split Landscaping    "
                }
            ],
            "selectedOptionType": "EXPENSIVE",
            "taskOptionAvailable": true,
            "taskState": "NOT_STARTED",
            "taskName": "Driveway/Landscaping"
        },
        {
            "type": "ProjectPlanOption",
            "numberOfWorkers": null,
            "overTimeOptionAvailable": false,
            "cheaperOptionOverTimeCost": 0,
            "standardOptionOverTimeCost": 0,
            "expensiveOptionOverTimeCost": 0,
            "cheaperOverTimeDays": 0,
            "standardOverTimeDays": 0,
            "expensiveOverTimeDays": 0,
            "localSupplierDays": null,
            "localSupplierCost": null,
            "localSuppilerOptionName": null,
            "localSupplierOptionAvailable": true,
            "taskId": "Z",
            "taskOptionType": "",
            "pmTaskOptions": [
                {
                    "taskId": "Z",
                    "cost": 425,
                    "days": 1,
                    "optionType": "STANDARD",
                    "overTimeSelected": false,
                    "localSupplierSelected": false,
                    "companyName": null
                }
            ],
            "selectedOptionType": "STANDARD",
            "taskOptionAvailable": false,
            "taskState": "NOT_STARTED",
            "taskName": "Final Inspection"
        }
    ]
}
export const LANG = {
    TASK_B_TOOLTIP:'The subcontractor you choose will also be locked in for Tasks H and T.',
    TASK_H_TOOLTIP:'This subcontractor is the one you selected in Task B.',
    TASK_K_TOOLTIP:'The subcontractor you choose will also be locked in for Task W.',
    TASK_W_TOOLTIP:'This subcontractor is the one you selected in Task K.',
    TASK_I_TOOLTIP:'The subcontractor you choose will also be locked in for Task U.',
    TASK_U_TOOLTIP:'This subcontractor is the one you selected in Task I.',
}